<template>
	<div></div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
	name: 'PayFail',
	setup() {
		const route = useRoute();
		const router = useRouter();
		const store = useStore();

		const payInfo = JSON.parse(window.sessionStorage.getItem('payInfo'));
		const { serviceUid, serviceCode, accessToken } = payInfo;
		const { payUid, bookUid, pgCode, resultCode } = route.query;

		const failKcp = async () => {
			try {
				const result = await store.dispatch('book/FAIL_KCP', {
					serviceUid,
					params: {
						payUid,
						bookUid,
						accessToken,
					},
				});
				if (result) {
					store.dispatch('member/SET_ACCESS_TOKEN', accessToken);
					router.push({ name: 'Pay', params: { serviceCode, resultCode } });
					return;
				}
				alert('문제가 발생했습니다.');
				router.replace({ name: 'Main', params: { serviceCode } });
			} catch (error) {
				alert('문제가 발생했습니다.');
				router.replace({ name: 'Main', params: { serviceCode } });
			}
		};

		const failKakaoPay = async () => {
			try {
				const result = await store.dispatch('book/FAIL_KAKAO_PAY', {
					serviceUid,
					params: {
						payUid,
						bookUid,
					},
				});
				if (result) {
					await store.dispatch('member/SET_ACCESS_TOKEN', accessToken);
					router.push({ name: 'Pay', params: { serviceCode, resultCode } });
					return;
				}
				alert('문제가 발생했습니다.');
				router.replace({ name: 'Main', params: { serviceCode } });
			} catch (error) {
				alert('문제가 발생했습니다.');
				router.replace({ name: 'Main', params: { serviceCode } });
			}
		};

		if (pgCode === 'PGC-KCP') {
			failKcp();
		} else if (pgCode === 'PGC-KAKAOP') {
			failKakaoPay();
		}

		return { serviceCode, accessToken };
	},
};
</script>
